<template>
  <div class="">
    <b-modal
      v-model="internalShow"
      id="ViewEmailLog"
      centered
      hide-header-close
      size="lg"
      modal-class="custom-modal"
      @shown="getEmailLogDetails"
    >
      <template #modal-header>
        <div
          class="popUp-header text-center w-100"
          style="border-bottom: 0px !important"
        >
          <h4 class="heading-size">Sent Item Details</h4>
        </div>
        <b-button
          variant="close"
          aria-label="Close"
          class="position-absolute"
          style="right: 1rem; top: 1rem"
          @click="internalShow = false"
        >
          <span aria-hidden="true">&times;</span>
        </b-button>
      </template>
     <div class="modal-scrollable-wrapper">
  <div class="modal-scrollable scaled-content">
   <ul>
  <li>DATE: <strong>{{ formattedSentDate || 'N/A' }}</strong></li>
  <li>FROM: <strong>{{ logDetails.from_email }}</strong></li>
  <li>
    TO: 
    <span v-for="(email, index) in toEmails" :key="index" class="email-pill">
      {{ email }}
    </span>
  </li>
  <li>
    CC: 
    <span v-for="(email, index) in ccEmails" :key="index" class="email-pill">
      {{ email }}
    </span>
  </li>
  <li>
    BCC: 
    <span v-for="(email, index) in bccEmails" :key="index" class="email-pill">
      {{ email }}
    </span>
  </li>
  <li>Subject: <strong>{{ logDetails.email_subject }}</strong></li>
</ul>


    <div v-html="preview"></div>
  </div>
</div>

      <!-- No need for a separate close button here if using the custom header close -->
      <!-- <b-button
          variant="close-btn"
          class='btn-container'
          @click="internalShow = false"
      >
        <i class="fas fa-times"></i>
      </b-button> -->

      <template #modal-footer>
        <!-- Custom footer if needed, otherwise hide-footer will work -->
        <b-button variant="secondary" @click="internalShow = false">
          Close
        </b-button>
        <b-button
          class="univ-btn w-auto p-2 pe-3 ps-3 h-100 mt-1"
          @click="resendEmail()"
        >
          Resend
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "ViewDetails",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    emailId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      internalShow: this.show,
      logDetails: {},
      preview: '',
    };
  },
  watch: {
    show(newVal) {
      this.internalShow = newVal;
    },
    internalShow(newVal) {
      this.$emit("update:show", newVal);
    },
  },
  computed: {
      formattedSentDate() {
    if (!this.logDetails.sent_date) return 'N/A';
    const date = new Date(this.logDetails.sent_date);
    // Format: Sep 7, 2025, 07:32 AM
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  },

  toEmails() {
    if (!this.logDetails.email_log_details) return [];
    return this.logDetails.email_log_details
      .filter(item => item.recipient_type === 0)
      .map(item => item.to_email);
  },
  ccEmails() {
    if (!this.logDetails.email_log_details) return [];
    return this.logDetails.email_log_details  
      .filter(item => item.recipient_type === 1)
      .map(item => item.to_email);
  },
  bccEmails() {
    if (!this.logDetails.email_log_details) return [];
    return this.logDetails.email_log_details
      .filter(item => item.recipient_type === 2)
      .map(item => item.to_email);
  }
},
  methods: {
    async resendEmail() {
      let url = `v2/forward-resend-email`;
      let loader = this.$loading.show();
      try {
        const response= await axios.post(url, {
          id: this.emailId,
          action: "resend"
         });
         if(response.data.status === 'error'){
            this.$notify(response.data.message, "error");
            return;
         }
         this.$notify(response.data.message, "success");
      } catch (err) {
        this.$notify("An error occurred while resending email.", "error");
      } finally {
        loader.hide();
      }
    },

    // message center fetch email details
       async getEmailLogDetails(){
         let url = `v2/preview-email?`;
          let loader = this.$loading.show();
          try{
            const response= await axios.get(url,{
               params: { id: this.emailId } 
            });
            this.preview=response.data.data.previewContent;
            this.logDetails= response.data.data.emailLog;

          }catch(err){
            this.$notify("An error occurred while fetching email details.","error");
          }finally{
            loader.hide();
      }
    }
  },
};
</script>

<style scoped>
.btn-container {
  position: absolute;
  right: 1rem;
  top: 1rem;
  border: none;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  padding: 0;
}
.btn-container:hover {
  opacity: 0.75;
}
#ViewEmailLog .modal-header .btn-close {
  right: -0.5rem !important;
  top: -1.5rem !important;
  background: #fff !important;
  opacity: 1 !important;
}
#ViewEmailLog ul {
  padding: 0;
}
#ViewEmailLog ul li {
  list-style: none;
  padding: 0.5rem;
  /* font-weight: bold; */
  color: #2c3f58;
}
.status-bar {
  background-color: #efefef;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
}
/* Custom modal size */
.custom-modal {
  max-width: 800px;   /* increased width */
  width: 95%;         /* responsive width */
  max-height: 80vh;   /* increased height */
}

/* Wrapper makes the scrollable content take full modal body */
.modal-scrollable-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.5rem;
}

/* Scrollable content takes full width and height */
.modal-scrollable {
  width: 100%;
  max-height: 70vh;   /* allows more vertical space */
  overflow-y: auto;
  overflow-x: auto;
  padding: 1.5rem;    /* slightly more padding for bigger modal */
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

/* Optional: keep content at normal scale */
.scaled-content {
  transform: scale(1);
  transform-origin: top center;
}

/* Ensure preview content wraps */
.modal-scrollable div[v-html] * {
  word-break: break-word;
  white-space: normal;
  overflow-wrap: break-word;
}
.modal_body_ {
    overflow-y: auto;
    max-height: 600px;
}
.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;
}
.email-pill {
  display: inline-block;
  background-color: #052e5a; /* light blue background */
  color: #ffffff; /* dark blue text */
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  margin-right: 0.5rem; /* space between pills */
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}


</style>
